import { ProductType } from '@/@types';
import { useUser } from '@/components/context/user';
import { useEffect, useState } from 'react';

const useBookmark = <T extends ProductType>(product?: T) => {
  const [isSaved, setIsSaved] = useState(product?.isSaved || false);
  const { emitter } = useUser();
  useEffect(() => {
    if (!product) {
      return undefined;
    }
    const listener = ({ detail }) => {
      if (product?.id === detail.productId) {
        setIsSaved(detail.isSaved);
      }
    };
    emitter?.addEventListener('toggle-product-collection', listener);
    return () => {
      emitter?.removeEventListener('toggle-product-collection', listener);
    };
  }, [emitter, product]);
  if (!product) {
    return undefined;
  }
  return {
    ...product,
    isSaved,
  } as T;
};

export default useBookmark;
